import PropTypes from 'prop-types';
import { useMemo } from 'react';
// @mui
import { CssBaseline } from '@mui/material';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import { createTheme, StyledEngineProvider } from '@mui/material/styles';
//
import typography from './typography';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// import GlobalStyles from './globalStyles';
// ----------------------------------------------------------------------

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

export default function ThemeProvider({ children }) {
  
  const themeOptions = useMemo(() => ({
    palette: {
      background: {default: '#FFFFFF',}
    },
      shape: { borderRadius: 10 },
      typography,
      components: {
          MuiTextField: {
              styleOverrides: {
                  root: {
                      '& .MuiInputBase-input': {
                          textTransform: 'uppercase', // Capitalize text
                      },
                  },
              },
          },
      },
    // shadows: shadows(),
    // customShadows: customShadows(),
  }), []);
    
  const theme = createTheme(themeOptions);
  // theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {/* <GlobalStyles /> */}
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  )
}
